/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Unbezahlterurlaub2Inputs */



/**

* @param {_Class_Unbezahlterurlaub2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_unbezahlterurlaub2 = /** @type {((inputs?: _Class_Unbezahlterurlaub2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Unbezahlterurlaub2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("unbezahlter Urlaub")
});
export { _class_unbezahlterurlaub2 as "_class_UnbezahlterUrlaub" }